import type { ReactNode } from 'react'

import { DropdownMenuContent, DropdownMenuSeparator } from '@/components/ui/dropdown-menu'
import { SidebarChatActionsPrimary } from './sidebar-chat-actions-primary.molecule'
import { SidebarChatActionsSecondary } from './sidebar-chat-actions-secondary.molecule'
import type { ChatItemActions } from './sidebar-item-actions.interface'

interface SidebarChatActionsMenuProps {
  chatId: string
  isPinned?: boolean
  actions: ChatItemActions
}

export const SidebarChatActionsMenu = ({
  chatId,
  isPinned = false,
  actions,
}: SidebarChatActionsMenuProps): ReactNode => (
  <DropdownMenuContent side="right" align="start" className="w-48">
    <SidebarChatActionsPrimary chatId={chatId} actions={actions} />
    <DropdownMenuSeparator />
    <SidebarChatActionsSecondary chatId={chatId} isPinned={isPinned} actions={actions} />
  </DropdownMenuContent>
)
